import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SurprisePageDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getSurpriseMeta = (ticker: string) => {
    return this.http.get(
      `${this.apiEP}/api/get_surprise_dashboard_meta/?company=${ticker}`,
    );
  };

  getPgData = (
    period: string,
    pg: string,
    ticker: string,
    source: string,
    revision: string,
  ) => {
    const queries = [
      `period=${period}`,
      `pg=${pg}`,
      `cut=NMV`,
      `ticker=${ticker}`,
      `source=${source}`,
      `source=VA Actuals`,
      `revision=${revision}`,
      `revision=PreQ`,
      `growthType=Analytics`,
      `basis=All`,
      `depth=default`,
      `surprise=Surprise`,
      `basesurprisesource=VA Actuals`,
      `is_surprise_page=true`,
    ];
    return this.http.get(`${this.apiEP}/api/pg?${queries.join("&")}`);
  };

  //https://app.visiblealpha.com/api/get_revision_dashboard_lineitems/?version=1&pg=MON&cut=NMV&ticker=AAL
  getLineitemsData = (pg: string, cut: string, ticker: string) => {
    const queries = [`version=1`, `pg=${pg}`, `cut=${cut}`, `ticker=${ticker}`];
    return this.http.get(
      `${this.apiEP}/api/get_revision_dashboard_lineitems/?${queries.join(
        "&",
      )}`,
    );
  };

  getParamData = (params) => {
    const queries = [
      `param=${params.paramId}`,
      `period=${params.period}`,
      `ticker=${params.ticker}`,
      `pg=${params.pg}`,
      `cut=${params.cut}`,
      `revision=${params.revision}`,
      `revision=PreQ`,
      `growthType=Analytics`,
      `basis=All`,
      `depth=default`,
      `basesurprisesource=VA Actuals`,
      `surprise=Surprise`,
      `is_surprise_page=true`,
    ];

    params.sources.forEach((source) => {
      queries.push(`source=${source}`);
    });

    return this.http.get(`${this.apiEP}/api/param3?&${queries.join("&")}`);
  };

  saveUserFilters = (
    jsonData: Record<string, any>,
    company: string,
  ): Observable<any> => {
    return this.http.post(
      `${this.apiEP}/api/surprise_dashboard_history/?ticker=${company}`,
      { company, jsonData, source: null, cut: null },
    );
  };
}
